// Store the original favicon href
let originalFavicon: string | null = null;

export const setNBMTMFavicon = () => {
  const favicon = document.querySelector('link[rel="icon"]') as HTMLLinkElement;
  if (favicon) {
    // Store the original favicon if we haven't already
    if (!originalFavicon) {
      originalFavicon = favicon.href;
    }
    favicon.href = '/nbmtm/favicon.ico';
  }
};

export const restoreOriginalFavicon = () => {
  const favicon = document.querySelector('link[rel="icon"]') as HTMLLinkElement;
  if (favicon && originalFavicon) {
    favicon.href = originalFavicon;
  }
}; 